<template>
  <header v-if="!$route.meta.hideHeader">
    <LoginNav v-if="navMode === 'login'"/>
    <MainNav :is-authenticated="isAuthenticated" v-else/>
  </header>
</template>

<script>
import MainNav from "@/components/nav/MainNav";
import LoginNav from "@/components/nav/LoginNav";
import AuthMixin from "@/mixins/AuthMixin";

export default {
  name: "Header",
  components: { LoginNav, MainNav },
  mixins: [ AuthMixin ],
  computed: {
    navMode()
    {
      return this.$route.meta.navMode;
    }
  }
}
</script>

<style lang="scss">
.navbar-expand-lg .navbar-nav
{
  a.nav-link
  {
    font-weight: 500;

    @media (min-width: 992px)
    {
      display: flex;
      align-items: center;
      height: 100%;

      padding-right: 1.5rem;
      padding-left: 1.5rem;

      color: $font-light;

      &:hover
      {
        text-decoration: none;
        color: $font-light;
      }
    }
  }
}

a.navbar-brand
{
  font-weight: 500;
  font-size: 1.3rem;
  margin: 0 auto;

  color: $font-light;

  &:hover
  {
    text-decoration: none;
    color: $font-light;
  }
}

.nav-logo-wrapper
{
  display: inline-block;
  text-align: center;
  min-width: 20px;
  margin-right: 5px;
}

.nav-item svg,
.navbar-toggler-icon svg
{
  fill: $font-light;
}

.nav-item
{
  display: flex;
  align-items: center;

  position: relative;

  svg
  {
    margin-right: 10px;
  }
}

a.nav-link:hover,
.router-link-active
{
  background-color: $font-light;
  color: $primary-blue !important;

  svg
  {
    fill: $primary-blue;
  }
}

.navbar .dropdown-menu
{
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: $soft-highlight;

  @media (min-width: 992px)
  {
    display: none;
  }

  .dropdown-item
  {
    a
    {
      color: $font-dark;
    }

    a.nav-link:hover,
    .router-link-active
    {
      background-color: transparent;
      color: $primary-blue;

      &:hover
      {
        color: $primary-blue;
      }
    }
  }
}
</style>